import appConfig from "./appConfig";

export default function generateAppleNewsRegex(): RegExp {
    const { businessweekAppleNewsId, bloombergAppleNewsId } = appConfig();

    return new RegExp(`applenews://(.+)/(${ businessweekAppleNewsId }|${ bloombergAppleNewsId })`);
}
